export enum Role {
  Admin = "ADMIN",
  Staff = "STAFF",
  Service_provider = "SERVICE_PROVIDER",
  Agrodealer = "AGRIBUSINESS_OWNER",
  Manufacturer = "MANUFACTURER",
  Warehouse = "WAREHOUSE",
  Driver = "DRIVER",
  user = "user",
  farmer = "FARMER",
  User = "User",
VETERINARIAN="VETERINARIAN",
}